<template>
  <div>
    <navbar></navbar>
    <div class="container is-fullheight hero-body">
        <div class="columns is-centered">
            <div class="column is-6">
				        <login-logo></login-logo>
                <h3 class="title has-text-centered has-text-dark">Member Login</h3>
                <div class="box">
                    <b-field label="E-Mail">
                        <b-input v-model="username" type="email" placeholder="E-Mail">
                        </b-input>
                    </b-field>

                    <b-field label="Password">
                        <b-input v-model="password" type="password" placeholder="Password" minlength="6" password-reveal>
                        </b-input>
                    </b-field>
                    <b-field>
						        <a class="password-remind-link has-text-dark is-pulled-right" @click="passwordReminder()">I forgot my password</a>
                    </b-field>
                    <button class="button is-dark is-large is-fullwidth" @click="doLogin()">
                        Login
                    </button>
                    <h3 v-if="isBadLogin" >Incorrect Email or Password. Please try again.</h3>

                </div>
                <div class="has-text-centered">
                  <router-link to="/register">Signup!</router-link>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

import Navbar from "./features/Navbar"
import LoginLogo from "./features/LoginLogo"
import PasswordForgot from "./modals/PasswordForgot"
import LoginModal from "./modals/LoginModal"
import { AUTH_REQUEST, AUTH_RESTAPI } from "../store/actions/auth";
import { USER_REQUEST, USER_RESTAPI } from "../store/actions/user";
import { mapState , mapGetters} from "vuex";

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      isBadLogin: false,
    }
  },
  components: {
	Navbar,
	LoginLogo,
  LoginModal,
	PasswordForgot
  },
  computed: {
  ...mapState({ token: state => state.auth.token, isAuthenticated: 'isAuthenticated' }),
  ...mapGetters({  isAuthenticated: 'isAuthenticated' }),

    },
  methods: {
    passwordReminder() {
      this.$modal.open({
        parent: this,
        component: PasswordForgot,
        hasModalCArd: true,
        props: {
        }
      })
	},
	doLogin() {

  const { username, password } = this;
  this.$store.commit(AUTH_RESTAPI, this.$api.REST_API)
  this.$store.commit(USER_RESTAPI, this.$api.REST_API)

this.$store.dispatch(AUTH_REQUEST, { username, password }).then(() => {
console.log("**login.vue()***")
console.log(this.token)
console.log(this.isAuthenticated)

if( this.isAuthenticated) {
this.$router.push('/')

} else {
this.isBadLogin = true
    console.log("hmmm")
   console.log(this.isBadLogin)
}
//  this.$router.push("/oops");

	//	this.$router.push('/dashboard')
  });
/*
  this.$store.dispatch(USER_REQUEST, { username, password }).then(() => {
  console.log("**login.vue()***")
  console.log(this.token)
  console.log(this.isAuthenticated)

  //  this.$router.push("/oops");

  	//	this.$router.push('/dashboard')
    });
*/
  }
}
}
</script>

<style scoped>
.password-remind-link {
	margin-bottom: 10px;
}
.background-light {
	background-color: hsl(0, 0%, 96%);
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue